import { validateTidalLicense } from "../base/index.js";
class ApplicationStorage {
  constructor(useSession = false) {
    this.useSession = useSession;
  }
  get storage() {
    return this.useSession ? sessionStorage : localStorage;
  }
  get(key, remove = false) {
    const res = this.storage.getItem(key);
    if (remove) this.remove(key);
    return res ? res : void 0;
  }
  set(key, data) {
    this.storage.setItem(key, data);
    return this;
  }
  remove(key) {
    this.storage.removeItem(key);
    return this;
  }
  clear() {
    this.storage.clear();
    return this;
  }
}
const persistentStorage = new ApplicationStorage();
const tempStorage = new ApplicationStorage(true);
function setValue(key, value, useSession = false) {
  const storage = getStorage(useSession);
  return storage.set(key, value);
}
function getValue(key, remove = false, useSession = false) {
  const storage = getStorage(useSession);
  return storage.get(key, remove);
}
function removeValue(key, useSession = false) {
  const storage = getStorage(useSession);
  return storage.remove(key);
}
function getStorage(useSession = false) {
  return useSession ? tempStorage : persistentStorage;
}
validateTidalLicense();
export {
  getStorage,
  getValue,
  removeValue,
  setValue
};
//# sourceMappingURL=ApplicationStorage.js.map
